import { createContext, use } from 'react';

import type { Size, Variant } from './tokens';

// Internal to the Button system — not exported from the barrel. Lets
// `ButtonGroup` propagate variant + size to its `Button` / `IconButton` children.
export type ButtonGroupContextValue = {
  variant: Variant;
  size: Size;
};

export const ButtonGroupContext = createContext<ButtonGroupContextValue | null>(null);

export const useButtonGroup = () => use(ButtonGroupContext);
